import { render, staticRenderFns } from "./GrowthChart.vue?vue&type=template&id=2126ba35"
import script from "./GrowthChart.vue?vue&type=script&lang=js"
export * from "./GrowthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports